import { reactShell } from './config';

const { cognito } = reactShell;

export async function getCognitoTokens() {
    try {
        const session = await cognito.fetchAuthSession();
        if (!session.userSub) return null;

        const idTokenJwt = session.tokens!.idToken!;
        const accessTokenJwt = session.tokens!.accessToken;
        return { idTokenJwt, accessTokenJwt };
    } catch (err) {
        return null;
    }
}
